import fetchRequests from "Api/Fetch";
import Utils from "Utils";
const Api = {
  loginUser: (email, password) => {
    return fetchRequests.post("/authentication/users/login/", {
      user: {
        email,
        password,
      },
    });
  },
  otpRequest: (email) => {
    return fetchRequests.post("/authentication/users/otp-request/", {
      user: {
        email,
      },
    });
  },
  otpVerify: (email, otp_code) => {
    return fetchRequests.post("/authentication/users/otp-verify/", {
      user: {
        email,
        otp_code,
      },
    });
  },
  basicRegistration: (username, email, password) => {
    return fetchRequests.post("/authentication/users/register", {
      user: { username, email, password },
    });
  },
  getFormFields: () => {
    return fetchRequests.secured("/investors/dynamicvalues/");
  },
  getUserDetails: () => {
    return fetchRequests.secured("/investors/detail/");
  },
  getStartupForInvestor: (filters = {}) => {
    var url = "/investors/startups?";
    Object.entries(filters).forEach(([key, value]) => {
      url += `${key}=${value}&`;
    });
    url = url.slice(0, -1);
    return fetchRequests.secured(url);
  },
  changeStartupStatus: (
    startupID,
    investorID = null,
    action = null,
    deal_type = null,
    amount = null,
    hot_lead = null
  ) => {
    return fetchRequests.secured("/investors/startupaction/", "POST", {
      action,
      startupID,
      investorID,
      deal_type,
      amount,
      hot_lead,
    });
  },
  loginWithGoogle: (data) => {
    return fetchRequests.post("/authentication/users/sociallogin/", data);
  },
  currencyConverter: (fromCurrency, value) => {
    return fetchRequests.post("/investors/cconvertor/", {
      toCurrency: "USD",
      fromCurrency,
      value,
    });
  },
  getCurrencyCode: () => {
    return fetchRequests.get("/investors/currencycodes/");
  },
  updateInvestorProfilePut: (data) => {
    return fetchRequests.secured("/investors/create/", "PUT", data);
  },
  updateInvestorProfileForm: (data) => {
    return fetchRequests.securedFormApi("/investors/create/", "PATCH", data);
  },
  getContractsOfInvestor: () => {
    return fetchRequests.secured("/investors/contracts/");
  },
  getUserNotifications: () => {
    return fetchRequests.secured("/notify/getusernotifications/");
  },
  markAsRead: (data) => {
    return fetchRequests.secured(
      "/notify/updateusernotifications/",
      "POST",
      data
    );
  },
  filterInvestor: (data) => {
    var url = "/investors/all/?";
    url = Utils.urlQueryBuilder(url, data);
    return fetchRequests.secured(url);
  },
  getStartupFromId: (startupId) => {
    return fetchRequests.secured(`/startups/${startupId}`);
  },
  getChatData: (investorID, startupID) => {
    return fetchRequests.secured(
      `/moderators/investorstartupfiles/?startupID=${startupID}&investorID=${investorID}`
    );
  },
  getAllInvestor: (page = 1, filters) => {
    let url = `/investors/all/?page=${page}&`;
    url = Utils.urlQueryBuilder(url, filters);
    return fetchRequests.secured(url);
  },
  getMails: (page) => {
    return fetchRequests.secured(`/mail/mailinglist/?page=${page}`);
  },
  createMails: (data) => {
    return fetchRequests.secured("/mail/mailinglist/", "POST", data);
  },
  deleteMails: (mailID) => {
    return fetchRequests.secured(`/mail/mailinglist/${mailID}`, "DELETE");
  },
  getAllStartups: (page = 1, filters = null) => {
    let url = `/moderators/startups?page=${page}&`;
    url = Utils.urlQueryBuilder(url, filters);
    return fetchRequests.secured(url);
  },
  updateStartupData: (startupID, data) => {
    return fetchRequests.secured(`/startups/${startupID}/`, "PUT", data);
  },
  getMatches: (startupID, page = 1, search = "", sort = "", type = "", relationship_manager = "", tags = "", sector = "") => {
    return fetchRequests.secured(
      `/moderators/prefmatches/?startupID=${startupID}&page=${page}&search=${search}&sort=${sort}&investor_type=${type}&relationship_manager=${relationship_manager}&tags=${tags}&sector=${sector}`
    );
  },
  getmatchedstartups: (investorID) => {
    return fetchRequests.secured(
      `/investors/getmatchedstartups/?investorID=${investorID}`
    );
  },
  assignStartup: (investorIDs, startupID, sendEmail) => {
    var data = {
      investorIDs,
      startupID,
      sendEmail,
    };
    return fetchRequests.secured(
      "/moderators/multipleinvestorstartupdata/",
      "POST",
      data
    );
  },
  createStartup: (data) => {
    // return fetchRequests.securedFormApi("/startups/create/", "POST", data);
    return fetchRequests.secured("/moderators/startups/", "POST", data);
  },
  createChat: (data) => {
    return fetchRequests.securedFormApi(
      "/moderators/investorstartupfiles/",
      "POST",
      data
    );
  },
  getStartupFromInvestorID: (
    investorID,
    startupID = null,
    filters = null,
    page = null,
    search = null
  ) => {
    let url = `/moderators/investorstartupslist/?investorID=${investorID}`;
    if (startupID) {
      url = `/moderators/investorstartupslist/?investorID=${investorID}&startupID=${startupID}`;
    }
    if (page) {
      url = `${url}&page=${page}`;
    }
    if (search) {
      url = `${url}&search=${encodeURIComponent(search)}`;
    }
    if (filters) {
      const queryParams = new URLSearchParams(filters);
      url = `${url}&${queryParams.toString()}`;
    }
    console.log("🚀 ~ file: Api.js ~ line 152 ~ url", url);
    return fetchRequests.secured(url);
  },
  getInvestorsDataFromStartupID: (
    startupID,
    serializeWith,
    page = null,
    search = null,
    filters = null
  ) => {
    let url = `/moderators/investorstartupslist/?startupID=${startupID}&serializeWith=${serializeWith}`;
    if (page) {
      url += `&page=${page}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (filters) {
      const queryParams = new URLSearchParams(filters);
      url = `${url}&${queryParams.toString()}`;
    }
    return fetchRequests.secured(url);
  },
  deleteStartup: (startupID) => {
    return fetchRequests.secured(`/startups/${startupID}/`, "DELETE");
  },
  changePswdRequest: (email) => {
    return fetchRequests.post(`/authentication/users/changepassrequest/`, {
      email,
    });
  },
  changePswd: (token, newPassword) => {
    return fetchRequests.post(`/authentication/users/changepassbeforelogin/`, {
      token,
      newPassword,
    });
  },
  initiateSelling: (startupID, sellingShare) => {
    return fetchRequests.secured(`/investors/initiateselling/`, "POST", {
      startupID,
      sellingShare,
    });
  },
  bidOnStartup: (startupSellingID, biddingAmount) => {
    return fetchRequests.secured(`/investors/intiatebidding/`, "POST", {
      startupSellingID,
      biddingAmount,
    });
  },
  approveBidding: (biddingID) => {
    return fetchRequests.secured(`/moderators/approvebidding/`, "POST", {
      biddingID,
      approval_status: true,
    });
  },
  getSellingStartup: () => {
    return fetchRequests.secured(`/moderators/sellingstartups/`);
  },
  getAllSellingStartup: () => {
    return fetchRequests.secured(`/moderators/v2/sellingstartups/`);
  },
  getStartupBidders: (sellingID) => {
    return fetchRequests.secured(`/moderators/bidders/?sellingID=${sellingID}`);
  },
  getBuyingStartup: () => {
    return fetchRequests.secured(`/investors/getmybuyingstartups/`);
  },
  getInvestorSellingStartup: () => {
    return fetchRequests.secured(`/investors/getmysellingstartups/`);
  },
  cancelSelling: (sellingID) => {
    return fetchRequests.secured(`/investors/cancelselling`, "POST", {
      sellingID,
    });
  },
  createContract: (data) => {
    return fetchRequests.secured(`/moderators/createcontract/`, "POST", data);
  },
  createInvestor: (data) => {
    return fetchRequests.secured(`/moderators/createinvestor/`, "POST", data);
  },
  deleteInvestor: (investor_id) => {
    return fetchRequests.secured(
      `/moderators/investors/${investor_id}`,
      "DELETE"
    );
  },
  editInvestor: (investor_id, data) => {
    return fetchRequests.secured(
      `/moderators/investors/${investor_id}/`,
      "PUT",
      data
    );
  },
  generateReport: (data, filters) => {
    let url = `/moderators/generatereport/?`;
    url = Utils.urlQueryBuilder(url, filters);
    return fetchRequests.secured(url, "POST", data);
  },
  getAllContracts: () => {
    return fetchRequests.secured(`/moderators/contracts/`);
  },
  searchChats: (searchText, page = 1) => {
    return fetchRequests.secured(`/startups/chats/?page=${page}`, "POST", {
      description: searchText,
    });
  },
  getMailFormFields: () => {
    return fetchRequests.secured(`/mail/fields/`);
  },
  getInvestorsFromIds: (investors = []) => {
    return fetchRequests.get(`/mail/investorsFromId/?investors=${investors}`);
  },
  createMailTemplate: (data) => {
    return fetchRequests.secured("/mail/template/", "POST", data);
  },
  editMailTemplate: (template_id, data) => {
    return fetchRequests.secured(
      `/mail/template/${template_id}`,
      "PATCH",
      data
    );
  },
  deleteMailTemplate: (template_id, data) => {
    return fetchRequests.secured(`/mail/template/${template_id}`, "DELETE");
  },
  mailAttachments: (file) => {
    var form = new FormData();
    file.forEach((f, index) => {
      form.append(`files[${index}]`, f);
    });
    return fetchRequests.securedFormApi(`/mail/attach/`, "POST", form);
  },
  mailLog: (page = 1) => {
    return fetchRequests.get(`/mail/log/?page=${page}`);
  },
  getReminders: (type, id) => {
    return fetchRequests.get(`/moderators/reminders/${id}/${type}`);
  },
  createReminders: (type, id, data) => {
    return fetchRequests.post(`/moderators/reminders/${id}/${type}`, data);
  },
  deleteReminders: (id) => {
    return fetchRequests.secured(
      `/moderators/reminders/delete/${id}`,
      "DELETE"
    );
  },
  uploadPostInlineImage: (data) => {
    return fetchRequests.securedFormApi(`/moderators/upload/`, "POST", data);
  },
  getStartupName: (id) => {
    return fetchRequests.post("/startups/getName/", { id });
  },
  getStartupInvestmentDetail: (startup, investor) => {
    return fetchRequests.get(
      `/startups/getUpdateInvestmentDetail/?startup=${startup}&investor=${investor}`
    );
  },
  updateStartupInvestmentDetail: (startup, investor, data) => {
    return fetchRequests.secured(
      `/startups/getUpdateInvestmentDetail/?startup=${startup}&investor=${investor}`,
      "PUT",
      data
    );
  },
  getStartupDetail: (startupId) => {
    return fetchRequests.get(`/startups/detail/${startupId}/`);
  },
  getInvestorIdsFromEmail: (investors) => {
    return fetchRequests.post(`/investors/getInvestorIdsFromEmail/`, {
      investors,
    });
  },
  runAllMatchTask: () => {
    return fetchRequests.get(`/moderators/generateMatches/`);
  },
  bulkUploadInvestor: (data) => {
    return fetchRequests.securedFormApi(
      "/moderators/uploadBulkInvestors/",
      "POST",
      data
    );
  },
  checkAllMatchTaskStatus: (type) => {
    return fetchRequests.get(`/moderators/getTaskResult/?id=${type}`);
  },
  getBulkInvestorTemplateLinks: () => {
    return fetchRequests.get(`/moderators/getTemplates/`);
  },
  runMatchScriptForStartup: (startupId) => {
    return fetchRequests.post(`/moderators/runMatchScriptForStartup/`, {
      startupId,
    });
  },
};
export default Api;
